import { ACTION_TYPES } from "reducers/actionTypes";
import { createLoadingReducer } from "reducers/HigherOrderReducers";

const initialSelectInstitution = {
  selectedInstitution: null,
};

const initialCoursesByInstitution = {
  coursesByInstitution: null,
};

const initialSelectState = {
  activeState: undefined,
  knowAtar: false,
  focusSelect: undefined,
};
export const selectStateReducer = (state = initialSelectState, action) => {
  switch (action.type) {
    case ACTION_TYPES.state.update:
      return Object.assign({}, state, {
        ...action.data,
        focusSelect: undefined,
      });
    case ACTION_TYPES.state.reset:
      return Object.assign({}, { ...initialSelectState, focusSelect: true });
    default:
      return state;
  }
};

const initialSubjects = { selectedSubjects: [], hscMarks: {} };
export const selectSubjectsReducer = (state = initialSubjects, action) => {
  switch (action.type) {
    case ACTION_TYPES.subjects.update:
      return Object.assign({}, state, action.data);
    case ACTION_TYPES.subjects.reset:
      return Object.assign({}, initialSubjects);
    default:
      return state;
  }
};

const initialAtar = { atar: 0 };
export const atarReducer = (state = initialAtar, action) => {
  switch (action.type) {
    case ACTION_TYPES.atar.update:
      return Object.assign({}, state, action.data);
    case ACTION_TYPES.atar.reset:
      return Object.assign({}, initialAtar);
    default:
      return state;
  }
};
const initialFields = {
  loading: false,
  error: null,
  success: false,
  studyFields: { category: [], other: [] },
};
export const fieldsReducer = createLoadingReducer(
  ACTION_TYPES.fields,
  initialFields
);

const initialSelectedFieldOfStudy = {
  selectedFieldOfStudy: null,
};
export const selectFieldOfStudyReducer = (
  state = initialSelectedFieldOfStudy,
  action
) => {
  switch (action.type) {
    case ACTION_TYPES.selectedFieldOfStudy.update:
      return Object.assign({}, state, action.data);
    case ACTION_TYPES.selectedFieldOfStudy.reset:
      return Object.assign({}, initialSelectedFieldOfStudy);
    default:
      return state;
  }
};

// export const ugReducer = (
//   state = {
//     loading: false,
//     error: null,
//     ug: initialUndergraduateInformation,
//   },
//   action
// ) => {
//   switch (action.type) {
//     case "LOAD_UNDERGRADUATE_INFORMATION_BEGIN":
//       return Object.assign({}, state, action.data, { loading: true });
//     case "LOAD_UNDERGRADUATE_INFORMATION_SUCCESS":
//       return Object.assign({}, state, action.data, {
//         loading: false,
//         error: null,
//         undergraduateInformation: action.payload,
//       });
//     case "LOAD_UNDERGRADUATE_INFORMATION_FAILURE":
//       return Object.assign({}, state, action.data, {
//         loading: false,
//         error: action.payload,
//       });
//     default:
//       return state;
//   }
// };

export const institutionsReducer = (
  state = {
    institutions: [],
  },
  action
) => {
  switch (action.type) {
    case "UPDATE_INSTITUTIONS":
      return Object.assign({}, state, action.data);
    default:
      return state;
  }
};

export const selectInstitutionReducer = (
  state = initialSelectInstitution,
  action
) => {
  switch (action.type) {
    case "UPDATE_SELECTED_INSTITUTION":
      return Object.assign({}, state, action.data);
    default:
      return state;
  }
};

export const coursesByInstitutionReducer = (
  state = initialCoursesByInstitution,
  action
) => {
  switch (action.type) {
    case "UPDATE_COURSES_BY_INSTITUTION":
      return Object.assign({}, state, action.data);
    default:
      return state;
  }
};

export const contextReducer = createLoadingReducer(ACTION_TYPES.context, {
  context: null,
  success: false,
  error: null,
  loading: false,
});

export const ugReducer = createLoadingReducer(ACTION_TYPES.ug, {
  ug: null,
  success: false,
  error: null,
  loading: false,
});
